// for cloud deployment
export const baseURL = 'http://batswap.electrifuel.com:4000/api/';
export const mqttURL = `ws://mbroker.electrifuel.com:9001`;
export const mapApiKey = 'AIzaSyDH1n0y0-ExbSdOqR_-pO_20E1hS-vrobk';

// // for localhost development
// export const baseURL = 'http://192.168.0.143:4000/api/';
// export const mqttURL = 'ws://192.168.0.143:8883';
// export const mapApiKey = 'AIzaSyDH1n0y0-ExbSdOqR_-pO_20E1hS-vrobk';
